import React, { Fragment, useState } from "react";
import { Dibpos, Help, Profile } from "../images";
import { Link, useNavigate } from "react-router-dom";
import { Menu, MenuButton, Transition } from "@headlessui/react";
import classNames from "../utils/classNames";
import Modal from "../components/Reuseable/Modal";
import About from "../components/About";
import { useSearchProduct } from "../components/PosScreen/globalState/allApis";
type Props = {
  screen?: any;
};

const NavbarLayout = (props: Props) => {
  const navigate = useNavigate();
  const { screen } = props;
  const updateSearchProduct = useSearchProduct(
    (state) => state.updateSearchProduct
  );
  const searchProduct = useSearchProduct((state) => state.searchProduct);
  const [isOpenHelper, setIsOpenHelper] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    navigate("/login", { replace: true });
  };
  return (
    <>
      <div className="font-sans w-full h-[42px] bg-[#4338CA] text-white flex items-center">
        <div className="w-full flex justify-between p-5">
          <div className="flex justify-center items-center">
            <Link to={"/"}>
              <img src={Dibpos} className="cursor-pointer" title="Dibpos" />
            </Link>
          </div>
          {screen === "posScreen" ? (
            <input
              type="search"
              value={searchProduct}
              className="w-[200px] placeholder-white placeholder-center flex h-[30px] bg-primary border border-gray-300  rounded-[30px] p-2 focus:outline-none text-center text-[14px]"
              placeholder="Search product/Enter code"
              onChange={(e: any) => updateSearchProduct(e.target.value)}
            />
          ) : (
            ""
          )}
          <div className="flex">
            <img
              src={Help}
              className="cursor-pointer"
              title="Help"
              onClick={() => setIsOpenHelper((pre: boolean) => !pre)}
            />
            {screen === "login" ? (
              ""
            ) : (
              <Menu as="div" className="w-full ml-2 relative">
                {({ open }) => (
                  <>
                    <div>
                      <MenuButton className="h-8 w-8 flex items-center justify-center text-sm rounded-full focus:outline-none">
                        <span className="sr-only">Open user menu</span>
                        <img
                          className="h-6 w-6 rounded-full"
                          src={Profile}
                          alt=""
                        />
                      </MenuButton>
                    </div>
                    <Transition
                      show={open}
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        static
                        className="origin-top-right absolute right-0 mt-2 w-48 z-10 rounded-md shadow-lg py-1 bg-white  focus:outline-none"
                      >
                        <Menu.Item>
                          <Link
                            to={"/profile"}
                            className={classNames(
                              "block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                            )}
                          >
                            Profile
                          </Link>
                        </Menu.Item>
                        {/* @ts-ignore */}

                        <Menu.Item>
                          <button
                            className={classNames(
                              "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                            )}
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </>
                )}
              </Menu>
            )}
          </div>
        </div>
      </div>
      <Modal
        isOpen={isOpenHelper}
        setIsOpen={setIsOpenHelper}
        children={<About />}
        title="About"
      />
    </>
  );
};

export default NavbarLayout;
